import { useInterviewAnswer } from 'builder/views/Interview/hooks/useInterviewAnswer'
import { useI18n } from 'builder/hooks/useI18n'
import { Interview } from 'builder/modules/interview/types'
import NoFeedbackImg from 'builder/views/Interview/view/FeedbackView/assets/no_feedback.png'
import { BtnTryAgain } from '../BtnTryAgain/BtnTryAgain'
import { IdealAnswerSection } from '../IdealAnswerSection/IdealAnswerSection'
import { CardSection } from '../CardSection/CardSection'
import { FeedbackSection } from '../FeedbackSection/FeedbackSection'
import { InvalidFeedback, InvalidFeedbackLeft } from './styles'

export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2`
const PanelContent: React.FC<{
  questionId: number
  interviewId: number | undefined
  interview: Interview
  index: number
  isUserPremium: boolean
}> = ({ questionId, interviewId, interview, isUserPremium, index }) => {
  const { data: answer } = useInterviewAnswer(questionId)
  const { i18n } = useI18n()

  return answer?.ai_speech_job?.status === 'failed' || answer?.audio === null ? (
    <>
      <InvalidFeedback>
        <InvalidFeedbackLeft>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.t(`${TRANSLATION_PREFIX}.no_feedback`),
            }}
          />
          {interviewId && (
            <div>
              <BtnTryAgain interviewId={interviewId} />
            </div>
          )}
        </InvalidFeedbackLeft>
        <img src={NoFeedbackImg} alt="no feedback" />
      </InvalidFeedback>
    </>
  ) : (
    <>
      <FeedbackSection
        answer={answer}
        interview={interview}
        selectedQuestionIndex={index}
        interviewId={interview.id}
      />

      <CardSection feedback={answer?.feedback} isUserPremium={isUserPremium} />
      <IdealAnswerSection
        feedback={answer?.feedback}
        interview={interview}
        enablePaywall={!isUserPremium}
      />
    </>
  )
}

export default PanelContent
